import { Cancel, PermMedia, AddPhotoAlternateOutlined, LocationOnOutlined } from "@material-ui/icons"
import Axios from "axios"
import { useContext, useEffect, useRef, useState } from "react"
import { AuthContext } from "../../context/AuthContext"
import { ProgressBar } from "react-bootstrap"
import { storage } from "../../firebase"
import Compressor from 'compressorjs'

import './share.css'
import LocationPopup from "../locationPopup/LocationPopup"

const Share = ({onPostShare}) => {
    const PF = process.env.REACT_APP_PUBLIC_FOLDER
    const API = process.env.REACT_APP_API_URL

    const description = useRef()

    const {user} = useContext(AuthContext)
    const [file, setFile] = useState(null)
    const [isVisible, setIsVisible] = useState(false)
    const [count, setCount] = useState(0)
    const [error, setError] = useState("")
    const [progress, setProgress] = useState(0)
    const [newPost, setNewPost] = useState({
        userId: user._id,
        description: "",
        image: "",
        likes: []
    })

    //Finalizing the post upload
    useEffect(() => {
        const postNupdate = async () => {
            if(count > 0 && (newPost.image || newPost.description)){
                try {
                    const {data : {post: {_id}}} = await Axios.post(API + "posts/create", newPost)
                    onPostShare({...newPost, _id: _id})
                    setNewPost({
                        userId: user._id,
                        description: "",
                        image: "",
                        likes: []
                    })
                    setFile(null)
                } catch (error) {
                    if(error.response && (error.response.status >= 400 && error.response.status <= 500)){
                        setError(error.response.data.msg)
                        setTimeout(() => {
                          setError("")
                        }, 3000)
                    }
                }
            }
            else{
                setCount(count + 1)
            }
        }
        postNupdate()
    }, [newPost, API])


    //Handle the file change
    const fileChangeHandler = (e) => {
        if(e.target.files[0]){
            //Compressing the image for less storage space in Firebase (A.K.A don't wanna pay :))
            new Compressor(e.target.files[0], {
                quality: 0.7,
                success : (compressedFile) => {
                    setFile(compressedFile)
                }
            })
            // setFile(e.target.files[0])
        }
    }

    //Handle the post submit
    const submitHandler = async (e) => {
        try {
            e.preventDefault()
            if(file){
                //Uploading the post image to Firebase
                const uploadTask = storage.ref(`posts/${file.name}`).put(file)
                uploadTask.on(
                    'state_changed',
                    (snapshot) => {  
                        const progressPercentage = snapshot.bytesTransferred * 100 / snapshot.totalBytes
                        console.log(progressPercentage)
                        setProgress(() => progressPercentage)
                    },
                    (error) => { console.log(error) },
                    async () => { 
                        const downloadURL = await storage.ref('posts').child(file.name).getDownloadURL()
                        setNewPost({...newPost, image: downloadURL, description: description.current.value})
                        setProgress(0)
                    }
                )
            }
            else{
                setNewPost({...newPost, description: description.current.value}) 
            }
            document.getElementById('description').innerText = ''
        } catch (error) {
            
        }
    }

    return (
        <div>
            <LocationPopup isVisible={isVisible} setIsVisible={setIsVisible}/>
            {
                error &&
                <div className="alert alert-danger w-100 text-center" role="alert">
                    {error}
                </div>
            }
            <div className="share">
                { progress !== 0 && <ProgressBar now={progress} className="myProgressBar"/> }
                <div className="shareWrapper">
                    <div className="shareTop">
                        <img src={user.profilePicture || (PF + "person/default_avatar.jpg")} alt="" className="shareProfileImg"/>
                        <input placeholder={`What's in your mind ${user.username} ?`} id="description" ref={description} className="shareInput"/>
                    </div>
                    <hr className="shareHr" />
                    {file && (
                        <div className="shareImgContainer">
                            <img className="shareImg" src={URL.createObjectURL(file)} />
                            <Cancel className="shareCancel" onClick={() => {setFile(null)}}/>
                        </div>
                    )}
                    <form className="shareBottom" onSubmit={submitHandler}>
                        <div className="shareOptions">
                            <label htmlFor="file" className="shareOption">
                                <AddPhotoAlternateOutlined className="shareIcon"/>
                                <span className="shareOptionText">Add a Photo</span>
                                <input type="file" style={{display: 'none'}} id="file" accept=".png, .jpeg, .jpg" onChange={fileChangeHandler}></input>
                            </label>
                            <div className="shareOption" onClick={() => setIsVisible(true)}>
                                <LocationOnOutlined className="shareIcon"/>
                                <span className="shareOptionText">Location</span>
                            </div>
                        </div>
                        <button className="shareButton" type="submit">Share</button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Share
